import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { titleStyle } from './Heading.tailwind';

interface PropsType {
  text: string;
  className?: string;
}

const Title: FC<PropsType> = props => {
  const { text, className } = props;

  const classes = twMerge(titleStyle, className);

  return <h1 className={classes}>{text}</h1>;
};

export default Title;
